export enum CompanyType {
  SARL = 'SARL',
  SA = 'SA',
  GIE = 'GIE',
  SAS = 'SAS',
  SUARL = 'SUARL',
  SCS = 'SCS',
  SNC = 'SNC',
  HOLDING = 'HOLDING',
}
